import globalNav from "./modules/global-nav";
import initAnim from "./modules/initAnim";
import inviewAnim from "./modules/inview";

window.addEventListener("load", (event) => {
  initAnim();
  globalNav();
  inviewAnim();
});